import React from "react";
import CreateAndUpdatePage from "../CreateAndUpdatePage";
function CreatePage() {
  return <CreateAndUpdatePage isUpdate={false} />;
}

export default CreatePage;
